window.addEventListener("hoContentLoaded", () => {
	Vue.component('progress-bar', {
		data: () => ({
			target : null,
			progress : null,
			y : -1,
		}),

		methods: {

			setup()
			{
				const parent = document.body;
				parent.appendChild(this.$el);

				this.target = document.querySelector("#body-scroll");
				this.progress = this.$el.querySelector(".progress-bar-progress");
			},

			anim()
			{
				const height = document.body.clientHeight - window.innerHeight;

				if(this.y !== window.scrollY)
				{
					let progress = (this.y / height) * 100; //(window.scrollY-y) / (height - window.innerHeight) * 100;
					this.setProgess(progress);
				}

				this.y = window.scrollY;
				requestAnimationFrame(this.anim);
			},

			setProgess(p)
			{
				let c = -100+p;

				if(p > 100)
					c = 0;

				this.progress.style.transform = "translateX("+(c)+"%)";
			},
		},

		mounted () {
			this.setup();
			this.anim();
		}
	});
});
